module.exports = __webpack_public_path__ + "media/bootstrap-icons/wrench-0832b9c9.svg";